// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Badge Styles */
.modern-badge {
  font-family: 'Inter', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  text-align: center;
}

.modern-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2), 0 3px 6px rgba(0, 0, 0, 0.15);
}

/* Popular Badge */
.badge-popular {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
}

/* Discount Badge */
.badge-discount {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  color: white;
}

/* Customizable Badge */
.badge-customizable {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
}

/* Badge container positioning */
.badge-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  z-index: 10;
}

/* Responsive badge sizes */
@media (max-width: 768px) {
  .modern-badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.5rem;
  }
}

@media (min-width: 769px) {
  .modern-badge {
    font-size: 0.75rem;
    padding: 0.15rem 0.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/badges.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kGAAkG;EAClG,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,wEAAwE;EACxE,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;IACjB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;AACF","sourcesContent":["/* Modern Badge Styles */\r\n.modern-badge {\r\n  font-family: 'Inter', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r\n  font-weight: 700;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n  backdrop-filter: blur(8px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  transition: all 0.3s ease;\r\n  text-align: center;\r\n}\r\n\r\n.modern-badge:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2), 0 3px 6px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Popular Badge */\r\n.badge-popular {\r\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\r\n  color: white;\r\n}\r\n\r\n/* Discount Badge */\r\n.badge-discount {\r\n  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);\r\n  color: white;\r\n}\r\n\r\n/* Customizable Badge */\r\n.badge-customizable {\r\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\r\n  color: white;\r\n}\r\n\r\n/* Badge container positioning */\r\n.badge-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  z-index: 10;\r\n}\r\n\r\n/* Responsive badge sizes */\r\n@media (max-width: 768px) {\r\n  .modern-badge {\r\n    font-size: 0.7rem;\r\n    padding: 0.25rem 0.5rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 769px) {\r\n  .modern-badge {\r\n    font-size: 0.75rem;\r\n    padding: 0.15rem 0.25rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
